import { CustomerTracker } from '@/components/office-tv/customer-tracker/CustomerTracker'
import { ItemsBoard } from '@/components/office-tv/items-board/ItemsBoard'
import { MetricsDashboard } from '@/components/office-tv/metrics/MetricsDashboard'
import { Header } from './Header'

export function DashboardGrid() {
  return (
    <div className="h-screen w-full flex flex-col bg-background overflow-hidden">
      <Header />
      <div className="flex-1 flex flex-col overflow-hidden p-3 gap-3">
        {/* Top row - Customer Tracker (3/4) and Items Board (1/4) */}
        <div className="flex-1 grid gap-3 min-h-0" style={{ gridTemplateColumns: '3fr 1fr' }}>
          <CustomerTracker />
          <ItemsBoard />
        </div>

        {/* Bottom row - Metrics only */}
        <div className="h-[140px]">
          <MetricsDashboard />
        </div>
      </div>
    </div>
  )
}
